import React from 'react';
import { GlobalOutlined } from '@ant-design/icons';
import { siDhl, siFedex, siUps } from 'simple-icons';

interface BrandLogo {
  path: string;
  /** 图形实际边界 [minX, minY, width, height]，simple-icons 统一画在 24×24 内 */
  box: [number, number, number, number];
  fg: string;
  bg?: string;
  /** 图形占徽标高度比例 */
  scale: number;
}

const BRANDS: { keywords: string[]; logo: BrandLogo }[] = [
  { keywords: ['DHL'], logo: { path: siDhl.path, box: [0, 10.3, 24, 3.4], fg: '#D40511', bg: '#FFCC00', scale: 0.6 } },
  { keywords: ['UPS'], logo: { path: siUps.path, box: [1.88, 0, 20.24, 24], fg: '#351C15', scale: 1 } },
  { keywords: ['FEDEX', '联邦'], logo: { path: siFedex.path, box: [0, 8.74, 24, 6.52], fg: '#4D148C', scale: 0.8 } },
];

/** 按承运商编码/名称关键词匹配品牌 logo（与 kfc-web CarrierLogo 一致） */
export function resolveCarrierBrand(code?: string, name?: string): BrandLogo | null {
  const text = `${code ?? ''} ${name ?? ''}`.toUpperCase();
  return BRANDS.find((b) => b.keywords.some((k) => text.includes(k)))?.logo ?? null;
}

const CarrierLogo: React.FC<{ code?: string; name?: string; height?: number }> = ({ code, name, height = 16 }) => {
  const brand = resolveCarrierBrand(code, name);
  const label = name || code || 'Carrier';
  if (!brand) {
    return <GlobalOutlined style={{ fontSize: height - 2, color: '#8c8c8c' }} aria-label={label} />;
  }
  const [x, y, w, h] = brand.box;
  const svgHeight = Math.round(height * brand.scale);
  const svgWidth = Math.round((svgHeight * w) / h);
  const padX = brand.bg ? Math.round(height * 0.3) : 0;
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height,
        padding: `0 ${padX}px`,
        borderRadius: 3,
        background: brand.bg,
        flex: 'none',
        verticalAlign: 'middle',
      }}
    >
      <svg viewBox={`${x} ${y} ${w} ${h}`} height={svgHeight} width={svgWidth} fill={brand.fg} aria-hidden>
        <path d={brand.path} />
      </svg>
    </span>
  );
};

export default CarrierLogo;
